import classesK from '../kalkulatori.module.css'
import { useState, Fragment, useEffect } from 'react'
import InfoBar from '../redesign/components/InfoBar'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'
import add from '../images/add.svg'
import runCalculator from '../api/runCalculator'

const calculatorType = 'Kosarka poeni igraca'

const KosarkaPoeniIgraca = () => {
  const [disabled, setDisabled] = useState(true)
  const [showInputArea, setShowInputArea] = useState(true)
  const [playerCount, setPlayerCount] = useState(1)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [data, setData] = useState({
    values: {
      odds: Array(3).fill(''), // [KI1, KIX, KI2]
      teamPoints: Array(6).fill(''), // [homeScored, homeConceded, homeGames, awayScored, awayConceded, awayGames]
      players: Array(5)
        .fill()
        .map(() => ({
          host: Array(3).fill(''), // [name, points, games]
          guest: Array(3).fill(''),
        })),
    },
    results: {
      prediction: {
        min: 0,
        avg: 0,
        max: 0,
      },
      players: Array(5)
        .fill()
        .map(() => ({
          host: {
            name: '',
            min: 0,
            avg: 0,
            max: 0,
          },
          guest: {
            name: '',
            min: 0,
            avg: 0,
            max: 0,
          },
        })),
      strength: {
        home: {
          SND: 0,
          SOD: 0,
        },
        away: {
          SNG: 0,
          SOG: 0,
        },
        combined: {
          SNDG: 0,
          SODG: 0,
        },
        balance: {
          SNDSOG: 0,
          SODSNG: 0,
        },
      },
    },
  })

  const teamStrengths = [
    {
      subtitle: 'Snaga domaćina',
      keys: ['SND', 'SOD'],
      source: data?.results?.strength?.home,
      names: ['SND ( snaga napada )', 'SOD ( snaga odbrane )'],
    },
    {
      subtitle: 'Snaga gosta',
      keys: ['SNG', 'SOG'],
      source: data?.results?.strength?.away,
      names: ['SNG ( snaga napada )', 'SOG ( snaga odbrane )'],
    },
    {
      subtitle: 'Snage oba tima zajedno',
      keys: ['SNDG', 'SODG'],
      source: data?.results?.strength?.combined,
      names: [
        'SNDG ( snaga napada domaćina i gosta )',
        'SODG ( snaga odbrane domaćina i gosta )',
      ],
    },
    {
      subtitle: 'Tim proseci odbrana i napada',
      keys: ['SNDSOG', 'SODSNG'],
      source: data?.results?.strength?.balance,
      names: [
        'SND + SOG ( dom. daje / gost prima )',
        'SOD + SNG ( dom. prima / gost daje )',
      ],
    },
  ]

  // determine if button is disabled
  useEffect(() => {
    const { odds, teamPoints, players } = data.values

    const oddsIncomplete = odds.some(
      (val) => val === '' || val === null || val === undefined
    )
    const teamPointsIncomplete = teamPoints.some(
      (val) => val === '' || val === null || val === undefined
    )

    const player1 = players[0]
    const hostIncomplete = player1.host.some(
      (val) => val === '' || val === null || val === undefined
    )
    const guestIncomplete = player1.guest.some(
      (val) => val === '' || val === null || val === undefined
    )
    const player1Incomplete = hostIncomplete || guestIncomplete

    setDisabled(oddsIncomplete || teamPointsIncomplete || player1Incomplete)
  }, [data.values])

  const clearFields = () => {
    setData({
      values: {
        odds: Array(3).fill(''),
        teamPoints: Array(6).fill(''),
        players: Array(5)
          .fill()
          .map(() => ({
            host: ['', '', ''],
            guest: ['', '', ''],
          })),
      },
      results: {
        prediction: {
          min: 0,
          avg: 0,
          max: 0,
        },
        players: Array(5)
          .fill()
          .map(() => ({
            host: {
              name: '',
              min: 0,
              avg: 0,
              max: 0,
            },
            guest: {
              name: '',
              min: 0,
              avg: 0,
              max: 0,
            },
          })),
        strength: {
          home: {
            SND: 0,
            SOD: 0,
          },
          away: {
            SNG: 0,
            SOG: 0,
          },
          combined: {
            SNDG: 0,
            SODG: 0,
          },
          balance: {
            SNDSOG: 0,
            SODSNG: 0,
          },
        },
      },
    })
    setPlayerCount(1)
    setShowInputArea(true)
    setError('')
  }

  const handleButtonClick = async () => {
    if (!showInputArea) {
      clearFields()
      setDisabled(true)
      return
    }

    const ok = await handleCalculate()
    if (ok) {
      setShowInputArea((prev) => !prev)
    }
  }

  // Build the API request body (English keys) from the input state, parsing
  // numbers exactly as the previous local code did (Number / parseFloat).
  const buildBody = (values) => {
    const [KI1, KIX, KI2] = values.odds.map(Number)
    const [
      homeScored,
      homeConceded,
      homeGames,
      awayScored,
      awayConceded,
      awayGames,
    ] = values.teamPoints.map(Number)

    // Per-side roster entry. The frontend collects total points + games, so we
    // derive the per-game average (avgPoints = points / games || 0) the same way
    // the old local code did (hostAvg = hostPoints / hostGames).
    const toPlayer = (side) => {
      const points = parseFloat(side[1])
      const games = parseFloat(side[2])
      const avgPoints = points / games || 0
      return {
        name: side[0] || '',
        matchesPlayed: Number.isFinite(games) ? games : 0,
        avgPoints,
      }
    }

    return {
      oddsHome: KI1,
      oddsDraw: KIX,
      oddsAway: KI2,
      homeGoalsScored: homeScored,
      homeGoalsConceded: homeConceded,
      homeMatchesPlayed: homeGames,
      awayGoalsScored: awayScored,
      awayGoalsConceded: awayConceded,
      awayMatchesPlayed: awayGames,
      homePlayers: values.players.map((player) => toPlayer(player.host)),
      awayPlayers: values.players.map((player) => toPlayer(player.guest)),
    }
  }

  const handleCalculate = async () => {
    setLoading(true)
    setError('')
    try {
      const body = buildBody(data.values)
      const res = await runCalculator('predictions', 'basketball-player-points', body)

      const team = res?.team ?? {}
      const homePlayers = res?.homePlayers ?? []
      const awayPlayers = res?.awayPlayers ?? []

      // Map the English response into the exact data.results shape the JSX reads.
      const updatedResults = {
        prediction: {
          min: `${team.expectedMinExactScore} : ${team.expectedMinExactScoreAway}`,
          avg: `${team.expectedAvgExactScore} : ${team.expectedAvgExactScoreAway}`,
          max: `${team.expectedMaxExactScore} : ${team.expectedMaxExactScoreAway}`,
          probabilities: {
            home: team.homeWinPct,
            draw: team.drawPct,
            away: team.awayWinPct,
          },
        },
        players: data.values.players.map((_, i) => ({
          host: {
            name: homePlayers[i]?.name ?? '',
            min: homePlayers[i]?.min ?? 0,
            avg: homePlayers[i]?.avg ?? 0,
            max: homePlayers[i]?.max ?? 0,
          },
          guest: {
            name: awayPlayers[i]?.name ?? '',
            min: awayPlayers[i]?.min ?? 0,
            avg: awayPlayers[i]?.avg ?? 0,
            max: awayPlayers[i]?.max ?? 0,
          },
        })),
        strength: {
          home: {
            SND: team.homeGoalsScoredAvg,
            SOD: team.homeGoalsConcededAvg,
          },
          away: {
            SNG: team.awayGoalsConcededAvg,
            SOG: team.awayGoalsScoredAvg,
          },
          combined: {
            SNDG: team.homeScoredAwayConcededAvg,
            SODG: team.homeConcededAwayScoredAvg,
          },
          balance: {
            SNDSOG: team.homeAwayScoredAvg,
            SODSNG: team.homeAwayConcededAvg,
          },
        },
      }

      setData((prev) => ({
        ...prev,
        results: updatedResults,
      }))
      return true
    } catch (err) {
      setError('Greška pri obračunu, pokušajte ponovo.')
      return false
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div className={classesK.container}>
        <InfoBar calculatorType={calculatorType} onRefresh={clearFields} />

        <div className={classesK.contentContainer}>
          <div className={classesK.submitWrapper}>
            <span>Unesi nove obračunske podatke</span>
            <button onClick={handleButtonClick} disabled={disabled || loading}>
              {showInputArea
                ? loading
                  ? 'Obračun u toku...'
                  : 'Prikaži rezultate'
                : 'Unesi obračunske podatke'}
            </button>
          </div>
          {error && <div className={classesK.errorMessage}>{error}</div>}
          {showInputArea && (
            <>
              <div className={classesK.sectionTitle}>
                Upiši kvote za ishod utakmice
              </div>
              <OddsCalculator
                data={data.values}
                field={'odds'}
                setData={setData}
                // calculation={handleCalculate}
                labelPrefix={['KI 1', 'KI X', 'KI 2']}
                type={Array(3).fill('number')}
                step={Array(3).fill('0.1')}
                min={Array(3).fill('1')}
                rows={3}
              />

              <div className={classesK.sectionTitle}>
                Upiši br. poena / br. ut. za oba tima
              </div>
              <OddsCalculator
                data={data.values}
                field={'teamPoints'}
                setData={setData}
                // calculation={handleCalculate}
                labelPrefix={[
                  'DOM + ( dom. dao poena )',
                  'DOM - ( dom. primio poena )',
                  'DOM BR. ( dom. odigrao utakmica )',
                  'GOST + ( gost. dao poena )',
                  'GOST - ( gost primio poena )',
                  'GOST BR. ( gost odigrao utakmica )',
                ]}
                type={Array(6).fill('number')}
                step={Array(6).fill('1')}
                min={Array(6).fill('1')}
                rows={3}
              />

              {Array.from({ length: playerCount }).flatMap((_, playerIndex) =>
                ['domaćin', 'gost'].map((role, roleIndex) => (
                  <Fragment key={`${playerIndex}-${role}`}>
                    <div className={classesK.sectionTitle}>
                      Upiši podatke za igrača {playerIndex + 1} - {role}
                    </div>
                    <OddsCalculator
                      data={data.values}
                      field={`players[${playerIndex}].${
                        role === 'domaćin' ? 'host' : 'guest'
                      }`}
                      setData={setData}
                      header={
                        playerIndex === 0
                          ? 'Obavezan unos-opcija igrač 1 (dom. ili gost)'
                          : 'Unos nije obavezan'
                      }
                      labelPrefix={[
                        'IGRAČ ( opciono ime, prezime, nadimak )',
                        'POENI ( ukupan broj poena )',
                        'BR. UTAK. ( broj ut. na koji se odnosi br. poena )',
                      ]}
                      type={['text', 'number', 'number']}
                      step={Array(3).fill('1')}
                      min={Array(3).fill('1')}
                      rows={2}
                      lastWide={true}
                    />
                  </Fragment>
                ))
              )}

              {playerCount < 5 && (
                <div className={classesK.addMore}>
                  <button
                    onClick={() => setPlayerCount((prev) => prev + 1)}
                    className={classesK.addButton}
                  >
                    <img src={add} height={18} width={18} alt='add' />
                    Dodaj još igrača
                  </button>
                </div>
              )}
            </>
          )}

          {!showInputArea && (
            <div className={classesK.sectionResults}>
              <ResultsSection
                title={`Tačan rezultat`}
                subtitle={`Opciono mogući tačan rezultat`}
                results={[
                  data?.results?.prediction?.min,
                  data?.results?.prediction?.avg,
                  data?.results?.prediction?.max,
                ]}
                names={[
                  'Predikcija minimalnog tačnog rezultata',
                  'Predikcija srednjeg tačnog rezultata',
                  'Predikcija maksimalnog tačnog rezultata',
                ]}
                rows={2}
              />

              {data?.results?.players
                ?.filter(
                  (player) =>
                    (player?.host?.name || player?.guest?.name) && // if host or guest have a name
                    ((player?.host?.min !== 0 &&
                      player?.host?.avg !== 0 &&
                      player?.host?.max !== 0) ||
                      (player?.guest?.min !== 0 &&
                        player?.guest?.avg !== 0 &&
                        player?.guest?.max !== 0))
                )
                .flatMap((player, playerIndex) =>
                  ['host', 'guest'].map((role, roleIndex) => {
                    const roleData = player[role]
                    const subtitle = `Poeni igrača ${playerIndex + 1} ( ${
                      role === 'host' ? 'domaćin' : 'gost'
                    } )`
                    const isFirst = playerIndex === 0 && roleIndex === 0

                    // check if this role has data
                    if (!roleData?.name) return null

                    return (
                      <ResultsSection
                        key={`${playerIndex}-${role}`}
                        title={isFirst ? 'Poeni igrača' : undefined}
                        subtitle={subtitle}
                        results={[
                          roleData?.name || '-',
                          roleData?.min ?? '-',
                          roleData?.avg ?? '-',
                          roleData?.max ?? '-',
                        ]}
                        names={[
                          'Igrač',
                          'Minimalni očekivani broj poena',
                          'Srednji očekivani broj poena',
                          'Maksimalni očekivani broj poena',
                        ]}
                        rows={2}
                      />
                    )
                  })
                )}

              {teamStrengths.map((config, index) => (
                <ResultsSection
                  key={index}
                  title={index === 0 ? 'Snage timova' : undefined}
                  subtitle={config.subtitle}
                  results={config.keys.map(
                    (key) => config.source?.[key] ?? '-'
                  )}
                  names={config.names}
                  rows={2}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default KosarkaPoeniIgraca
